module.exports = __webpack_public_path__ + "img/serve-country-02.23264b85.png";